/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import Navbar from "./navBar"
import logoNovus from "../images/novus_tec.png"
// Smooth scrolling using jQuery easing

const LayoutHome = ({ children, pageInfo }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQueryHome {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Container fluid className="px-0 main">
          <Row noGutters className="justify-content-center">
            <Col>
              <header className="masthead mastheadbackhome" >
                <div className="container d-flex h-100 align-items-center">
                  <div className="mx-auto text-center">
                    <h1 className="mx-auto my-0  cssanimation sequence fadeInBottom">OpenSocialLab</h1>
                    <h1 className="mx-auto my-0  cssanimation sequence fadeInBottom" style={{fontSize:`-webkit-xxx-large`}}>Emprendimiento social  y aprendizaje</h1>
                    <h2 className="mx-auto mt-2 mb-5 cssanimation sequence fadeInBottom" style={{color: `#fff`}}>Vinculación con aprendizaje vivencial para escalar niveles de dominio en competencias de emprendimiento social</h2>
                    <Link to="#about" className="btn js-scroll-trigger" style={{ background: `#00c3b6`, color:`#fff`}} > 
                    Conoce más
                    </Link>
                  </div>
                </div>
              </header>
            </Col>
          </Row>
          <Navbar pageInfo={pageInfo} />
          <Row noGutters>
            <Col>
              <Container className="mt-5 body-container">
                <main>{children}</main>
              </Container>
            </Col>
          </Row>
        </Container>
        <Container fluid className="px-0">
          <Row noGutters>
            <Col className="footer-col">
              <footer>
                <span>
                © {new Date().getFullYear()}, <a href="https://novus.itesm.mx/" rel="noopener noreferrer" className="link-no-style" style={{color:`#fff`}} target="_blank"><img src={logoNovus} alt="logoNovus" style={{maxHeight:`25px`}}/> Novus </a> - opensocialLab
                </span>
              </footer>
            </Col>
          </Row>
        </Container>
      </>
    )}
  />
)

export default LayoutHome
